var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSalary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#48A1D9",
  d: "M8 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM0 3v4.2l.8.8h1.7V5.5h11V8h1.7l.8-.8V3H0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#48A1D9",
  d: "M11.5 10.5c-.85 0-1.5.65-1.5 1.5H6c0-.85-.65-1.5-1.5-1.5V6h-1v7h9V6h-1v4.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#48A1D9",
  d: "M10 6.5c0-.2-.05-.35-.1-.5H6.15c-.05.15-.1.3-.1.5 0 .85.9 1.5 2 1.5S10 7.35 10 6.5Z"
})));
export default SvgSalary;